import { api } from './api';
import type { PlatformCredentials, PlatformStatus, SyncResponse } from '@/types/trading';

export const platformService = {
  async getStatus(): Promise<PlatformStatus> {
    const res = await api.get<Record<string, unknown>>('/platform/status');
    return {
      status: String(res.status ?? 'disconnected') as PlatformStatus['status'],
      platform: String(res.platform_type ?? 'alpaca'),
      isPaper: Boolean(res.is_paper ?? true),
      lastSync: res.last_sync ? String(res.last_sync) : null,
      error: res.last_error ? String(res.last_error) : undefined,
      accountId: res.account_info
        ? String((res.account_info as Record<string, unknown>).id ?? '')
        : undefined,
    };
  },

  async syncPositions(): Promise<SyncResponse> {
    const res = await api.post<Record<string, unknown>>('/platform/sync', { force: false });
    return {
      success: Boolean(res.success ?? false),
      syncedAt: String(res.synced_at ?? new Date().toISOString()),
      positionsCount: Number(res.positions_synced ?? 0),
      ordersCount: Number(res.orders_synced ?? 0),
      message: res.message ? String(res.message) : undefined,
    };
  },

  async updateCredentials(credentials: PlatformCredentials): Promise<void> {
    await api.put('/platform/credentials', {
      api_key: credentials.apiKey,
      api_secret: credentials.apiSecret,
      is_paper: credentials.isPaper,
    });
  },

  async testConnection(): Promise<{ valid: boolean; error?: string }> {
    const res = await api.post<Record<string, unknown>>('/platform/test');
    return {
      valid: Boolean(res.success ?? false),
      error: res.message ? String(res.message) : undefined,
    };
  },
};

export default platformService;
